import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-retry',
    templateUrl: './retry.component.html',
    styleUrls: ['./retry.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class RetryComponent {
    @Input() isLoading = false
    @Input() hasError = false
    @Input() errorMessage = ''

    @Output() onRetry = new EventEmitter<boolean>()

    public emit(): void {
        this.onRetry.emit(true)
    }
}
